import { Link, useNavigate } from "react-router-dom";
import { Logo } from "./Logo";
import { useAuth } from "../context/AuthContext";
import { Button } from "./ui/button";
import { LayoutDashboard, Shield, LogOut, Menu, X, Heart, Bell, User } from "lucide-react";
import { useState } from "react";
import { useFavorites } from "../hooks/useFavorites";
import { InstallButton } from "./InstallButton";

export const Navbar = () => {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const [open, setOpen] = useState(false);
  const { favs } = useFavorites();

  const doLogout = () => { logout(); nav("/"); setOpen(false); };

  const links = (
    <>
      <Link to="/recherche" onClick={() => setOpen(false)} className="font-semibold hover:text-street-gold transition-colors" data-testid="nav-search">Rechercher</Link>
      <Link to="/marches" onClick={() => setOpen(false)} className="font-semibold hover:text-street-gold transition-colors" data-testid="nav-markets">Marchés</Link>
      <Link to="/tarifs" onClick={() => setOpen(false)} className="font-semibold hover:text-street-gold transition-colors" data-testid="nav-pricing">Tarifs</Link>
      <Link to="/favoris" onClick={() => setOpen(false)} className="font-semibold hover:text-street-gold transition-colors flex items-center gap-1" data-testid="nav-favorites">
        <Heart size={16} className={favs.length ? "fill-coral-twist text-coral-twist" : ""} /> Favoris{favs.length > 0 && <span className="bg-coral-twist text-white text-[10px] font-bold rounded-full px-1.5">{favs.length}</span>}
      </Link>
      {user?.role === "admin" && (
        <Link to="/admin" onClick={() => setOpen(false)} className="font-semibold text-urban-teal flex items-center gap-1" data-testid="nav-admin"><Shield size={16} /> Admin</Link>
      )}
      {user ? (
        <>
          {user.role === "owner" && (
            <Link to="/dashboard" onClick={() => setOpen(false)} className="font-semibold flex items-center gap-1" data-testid="nav-dashboard"><LayoutDashboard size={16} /> Mon espace</Link>
          )}
          {user.role === "foodie" && (
            <Link to="/alertes" onClick={() => setOpen(false)} className="font-semibold flex items-center gap-1" data-testid="nav-alerts"><Bell size={16} /> Mes alertes</Link>
          )}
          <Link to="/compte" onClick={() => setOpen(false)} className="font-semibold flex items-center gap-1" data-testid="nav-account"><User size={16} /> Mon compte</Link>
          <Button onClick={doLogout} variant="ghost" className="gap-1 text-coral-twist hover:text-coral-twist" data-testid="nav-logout"><LogOut size={16} /> Déconnexion</Button>
          <InstallButton />
        </>
      ) : (
        <>
          <Link to="/connexion" onClick={() => setOpen(false)} className="font-semibold" data-testid="nav-login">Connexion</Link>
          <Button asChild className="rounded-full bg-street-gold hover:bg-street-gold/90 text-white font-bold shadow-warm">
            <Link to="/connexion?tab=signup" onClick={() => setOpen(false)} data-testid="nav-register">Référencer mon foodtruck</Link>
          </Button>
          <InstallButton />
        </>
      )}
    </>
  );

  return (
    <header className="sticky top-0 z-50 bg-cream-bg/85 backdrop-blur-xl border-b border-urban-teal/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">
        <Link to="/" data-testid="nav-home"><Logo /></Link>
        <nav className="hidden lg:flex items-center gap-6">{links}</nav>
        <button className="lg:hidden text-urban-teal" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle">{open ? <X /> : <Menu />}</button>
      </div>
      {open && <nav className="lg:hidden flex flex-col gap-4 px-6 py-5 bg-cream-bg border-b border-urban-teal/10 max-h-[80vh] overflow-y-auto">{links}</nav>}
    </header>
  );
};
